import { render, staticRenderFns } from "./LomTrainingQuestionCreate.vue?vue&type=template&id=1d06ea0a"
import script from "./LomTrainingQuestionCreate.vue?vue&type=script&lang=js"
export * from "./LomTrainingQuestionCreate.vue?vue&type=script&lang=js"
import style0 from "./LomTrainingQuestionCreate.vue?vue&type=style&index=0&id=1d06ea0a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports